module.exports = __webpack_public_path__ + "img/catch-video.5d582e0f.png";